<script lang="ts">
  import Image from "@components/Image.svelte"
  import IntersectionObserver from "@objects/IntersectionObserver.svelte"
  import type { AdUnit } from "@shared/models/AdUnit/AdUnit"
  import { trackAdUnitIntersection, trackAdUnitClick } from "@helpers/adInteraction"
  import i18n from "@/store/i18n"

  export let adUnit: AdUnit
</script>

<IntersectionObserver
  class="bg-beige-50 max-w-[400px] w-full relative"
  on:intersect={() => trackAdUnitIntersection(adUnit)}
>
  <a class="block" on:click={() => trackAdUnitClick(adUnit)} href={adUnit.content?.destination_url}>
    <Image src={adUnit.image?.url} width={350} fit="fit" alt={adUnit.content?.title} />

    <div class="p-4 pt-16 absolute bottom-0 left-0 w-full bg-gradient-to-t from-black to-transparent">
      <span class="text-xs text-gray-400">{$i18n.t("components.AdUnit.VendorCatalogContentCard.sponsored")}</span>

      <h1 class="mt-2 font-heading text-2xl line-clamp-2 tracking-tight text-white">
        {adUnit.content?.title}
      </h1>

      <p class="text-wrap text-white">
        {adUnit.content?.tagline}
      </p>

      <span class="inline-block mt-4 text-white">
        {adUnit.content?.cta_text}
      </span>
    </div>
  </a>
</IntersectionObserver>
